import React, {Component} from 'react';
import {connect} from 'react-redux';
import IframeHelper from '../../helpers/IframeHelper';
import {bindActionCreators} from 'redux';
import {changeSort} from '../../actions/SortActions';
import FlightTime from '../flights/FlightCard/FlightTime';
import {SORT_DEPARTURE_TIME, SORT_LOWEST_PRICE, SORT_SHORTEST_FLIGHTS} from '../../reducers/filters/SortReducer';

class SearchComponent extends Component {
    componentWillMount() {
        this.translator = JSON.parse(this.props.dataTranslations);
    }

    // TODO need to rework this, without using DOM
    toggleButton(className) {
        const elements = document.getElementsByClassName(className);
        for (let i = 0; i < elements.length; i++) {
            if (elements[i].classList.contains('d-none')) {
                elements[i].classList.remove('d-none');
            } else {
                elements[i].classList.add('d-none');
            }
            IframeHelper.updateHeight(this.props.parameters.projectUrl);
        }
    }

    sortChange(sortType) {
        if (sortType !== this.props.sortType) {
            this.props.changeSort(sortType);
        }
    }

    toggleSearchModal() {
        window.showMobileSearch();
    }

    renderRouteIcon() {
        if (this.props.parameters['search-params'].returnDate) {
            /* round trip — swap arrows */
            return (
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M8 3 4 7l4 4"/><path d="M4 7h16"/><path d="m16 21 4-4-4-4"/><path d="M20 17H4"/>
                </svg>
            );
        }
        /* one-way — arrow right */
        return (
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M5 12h14"/><path d="m13 6 6 6-6 6"/>
            </svg>
        );
    }

    render() {
        const route = JSON.parse(this.props.parameters.route);

        return (
            <div className="d-lg-none m-results-top">
                <div className="m-search-row">
                    <button
                        type="button"
                        className="m-search-pill"
                        onClick={this.toggleSearchModal}
                        data-toggle="modal"
                        data-target="#mobile-search"
                    >
                        <span className="m-search-pill__body">
                            <span className="m-search-pill__route">
                                {route.from.code}
                                <span className="m-search-pill__route-icon">{this.renderRouteIcon()}</span>
                                {route.to.code}
                            </span>
                            <span className="m-search-pill__meta">
                                <FlightTime
                                    returnDate={this.props.parameters['search-params'].returnDate}
                                    departureDate={this.props.parameters['search-params'].departureDate}
                                    adults={this.props.parameters['search-params'].adults}
                                    children={this.props.parameters['search-params'].children}
                                    infants={this.props.parameters['search-params'].infants}
                                    translator={this.translator}
                                />
                            </span>
                        </span>
                        <svg className="m-search-pill__chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <path d="m6 9 6 6 6-6"/>
                        </svg>
                    </button>
                    <button
                        type="button"
                        className={`m-filter-btn ${this.props.flights.flights.length ? '' : 'd-none'}`}
                        onClick={this.toggleButton.bind(this, 'js-filters')}
                        aria-label="Filter"
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <path d="M4 21v-7"/><path d="M4 10V3"/><path d="M12 21v-9"/><path d="M12 8V3"/><path d="M20 21v-5"/><path d="M20 12V3"/><path d="M2 14h4"/><path d="M10 8h4"/><path d="M18 16h4"/>
                        </svg>
                    </button>
                </div>
                <div className={`m-sort ${this.props.flights.flights.length ? '' : 'd-none'}`}>
                    <button type="button" className={`m-sort__tab ${this.props.sortType === SORT_LOWEST_PRICE ? 'is-active' : ''}`} onClick={() => this.sortChange(SORT_LOWEST_PRICE)}>
                        {this.translator['Lowest price']}
                    </button>
                    <button type="button" className={`m-sort__tab ${this.props.sortType === SORT_SHORTEST_FLIGHTS ? 'is-active' : ''}`} onClick={() => this.sortChange(SORT_SHORTEST_FLIGHTS)}>
                        {this.translator['Shortest flights']}
                    </button>
                    <button type="button" className={`m-sort__tab ${this.props.sortType === SORT_DEPARTURE_TIME ? 'is-active' : ''}`} onClick={() => this.sortChange(SORT_DEPARTURE_TIME)}>
                        {this.translator['Departure time']}
                    </button>
                </div>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeSort,
    }, dispatch);
}

function mapStateToProps(state, ownProps) {
    return {
        dataTranslations: ownProps.translations,
        parameters: state.ParametersReducer.parameters,
        flights: state.FlightsReducer,
        sortType: state.SortReducer.field,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchComponent);



// WEBPACK FOOTER //
// ./src/components/mobile/SearchComponent.js